import React from "react";
import AppRoutes from "./Routes/Routes";
import { ToastContainer } from "react-toastify";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-datepicker/dist/react-datepicker.css";

import "./Assets/sass/style.scss";
import "./Assets/css/animate.css";

const App = () => {
  return (
    <div className="app-container">
      <AppRoutes />
      <ToastContainer />
    </div>
  );
};

export default App;
